// src/components/News.js
import { isMobile } from 'react-device-detect'; // デバイスタイプの検出
import React from 'react';

const NewsPC = () => {
  return (
    <div className="news-wrapper bg-cover bg-center py-16" id="news-zone">
      <div className="flex flex-col w-full max-w-7xl mx-auto px-4">
        <div className="bg-whitesmoke w-full p-1 border-8 border-transparent mb-8">
          <div className="news-menu flex flex-col w-full">
            <h3 className="text-3xl font-bold text-left mb-4">NEWS</h3>
            <ul className="news-list overflow-y-scroll border-dotted border-gray-300 h-96">
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年10月3日  </span><span className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">ニュース</span><br />
                  参加者が12人になりました！<br />全国から参加をお待ちしております！
                </p>
              </li>
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="date w-1/6 text-gray-600">2024年10月3日</p>
                <p className="New inline-flex items-center bg-red-300 text-gray-800 border border-gray-800 rounded px-8 py-2 font-bold mr-12 text-center text-xs">
                  重要
                </p>
                <p className="news-text w-2/3">2025年9月に演奏会を開催いたします。詳細は<a href="/detail"　className="text-blue-500 underline hover:text-blue-700">詳細情報</a>をご確認ください。</p>
              </li>
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="date w-1/6 text-gray-600">2024年9月8日</p>
                <p className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">
                  ニュース
                </p>
                <p className="news-text w-2/3">本演奏会用のホームページを作成しました。参加希望の方は<a href="/apply"　className="text-blue-500 underline hover:text-blue-700">参加者フォーム</a>から</p>
              </li>
              {/* <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="date w-1/6 text-gray-600">2024年9月8日</p>
                <p className="New inline-block bg-yellow-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">
                  イベント
                </p>
                <p className="news-text w-2/3">次回練習日を更新しました。<a href="/schedule"　className="text-blue-500 underline hover:text-blue-700">スケジュール</a>をご確認ください。</p>
              </li> */}
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="date w-1/6 text-gray-600">2024年9月8日</p>
                <p className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">
                  ニュース
                </p>
                <p className="news-text w-2/3">インスタグラム、X、Youtubeアカウントを作成しました。ホームページからご確認ください。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const NewsMobile = () => {
  return (
    <div className="news-wrapper bg-cover bg-center py-1" id="news-zone">
      <div className="flex flex-col w-full max-w-7xl mx-auto px-4">
        <div className="bg-whitesmoke w-full p-1 border-8 border-transparent mb-8">
          <div className="news-menu flex flex-col w-full">
            <h3 className="text-3xl font-bold text-left mb-4 text-red-500">NEWS</h3>
            <ul className="news-list overflow-y-scroll border-dotted border-gray-300 h-96">
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年10月3日  </span><span className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">ニュース</span><br />
                  <font color="#FF0000">参加者が12人になりました！</font><br />全国から参加をお待ちしております！
                </p>
              </li>
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年10月3日    </span><span className="New inline-block bg-red-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">重要</span><br />
                  関西以外の方からの募集もあったため、<br />全国からの募集へ変更させていただきました！<a href="/detail" className="text-blue-500 underline hover:text-blue-700">詳細情報</a>
                  をご確認ください。
                </p>
              </li>
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年9月8日  </span><span className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">ニュース</span><br />
                  本演奏会用のホームページを作成しました。<br />参加希望の方は<a href="/apply"　className="text-blue-500 underline hover:text-blue-700">参加者フォーム</a>から
                </p>
              </li>
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年9月8日    </span><span className="New inline-block bg-red-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">重要</span><br />
                  2025年9月に演奏会を開催いたします。<br />演奏会の詳細や曲目などは<a href="/detail" className="text-blue-500 underline hover:text-blue-700">詳細情報</a>
                  をご確認ください。
                </p>
              </li>
              {/* <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年9月8日  </span><span className="New inline-block bg-yellow-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">イベント</span><br />
                  次回練習日を更新しました。<a href="/schedule"　className="text-blue-500 underline hover:text-blue-700">スケジュール</a>をご確認ください。
                </p>
              </li> */}
              <li className="flex items-center mb-4 border-b border-dotted border-gray-300 py-4">
                <p className="w-full text-gray-600">
                  <span className="font-bold">2024年9月8日  </span><span className="New inline-block bg-blue-300 text-gray-800 border border-gray-800 rounded px-5 py-2 font-bold mr-12 text-center text-xs">ニュース</span><br />
                  インスタグラム、Xを作成しました。<br />ホームページからご確認ください。
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );  
};

function News() {
  return isMobile ? <NewsMobile /> : <NewsPC />;
}

export default News;
